import { useAuth0 } from '@auth0/auth0-vue'
import { watch } from 'vue'
import { useConfigStore } from '@/legacy/store/modules/config'
import { useWhoAmI } from './whoAmI'

/**
 * Composable that reactively syncs the current user identity to Datadog
 * RUM and Logs clients whenever the current user's entityId changes.
 */
export function useDatadogUser() {
  const { selfEntityId } = useWhoAmI()
  const { user } = useAuth0()
  const configStore = useConfigStore()

  watch(selfEntityId, (newId) => {
    if (newId) {
      const datadogUser = {
        id: newId,
        name: user.value?.name,
        email: user.value?.email,
      }
      configStore.rumClient?.setUser(datadogUser)
      configStore.logsClient?.setUser(datadogUser)
    } else {
      configStore.rumClient?.clearUser()
      configStore.logsClient?.clearUser()
    }
  })
}
